import { FC } from 'react'
import _ from 'lodash'

import { cn } from '../../../../../../../../lib/utils'

import {
  HORSE_NAME_DEFAULT,
  IRegistrationByDayInterface,
} from '../../../../../../../../models/registrations-by-day/registrationByDay.interface'
import { IRegistrationTicketInterface } from '../../../../../../../../models/registration-tickets/registrationTicket.interface'
import { IRegistrationFeesInterface } from '../../../../../../../../models/registration-fees/registrationFees.interface'
import { ICount } from '../../TeamRegistrarTab'

interface TeamDescriptionProps {
  count: ICount
  registrationsByDay: IRegistrationByDayInterface[]
  registrationsFees: IRegistrationFeesInterface[]
  registrationsTickets: IRegistrationTicketInterface[]
}

export const TeamDescription: FC<TeamDescriptionProps> = ({
  count,
  registrationsByDay,
  registrationsFees,
  registrationsTickets,
}) => {
  // Calculate Entries
  const entriesTotal = _(registrationsByDay).map('id').uniq().size()
  const entriesScratched = _(registrationsByDay)
    .filter({ isScratched: true })
    .map('id')
    .uniq()
    .size()

  // Calculate Fees
  const feesTotal = _(registrationsFees).map('id').uniq().size()
  const feesScratched = _(registrationsFees).filter({ isScratched: true }).map('id').uniq().size()

  // Calculate Tickets
  const ticketsTotal = _(registrationsTickets).map('id').uniq().size()
  const ticketsScratched = _(registrationsTickets)
    .filter({ isScratched: true })
    .map('id')
    .uniq()
    .size()

  // Calculate Horses
  const horsesTotal = _(registrationsByDay)
    .flatMap((r) => r.horsesSelected ?? [])
    .map('id')
    .filter((id) => id !== HORSE_NAME_DEFAULT)
    .uniq()
    .size()
  const horsesScratched = _(registrationsByDay)
    .flatMap((item) =>
      (item.horsesSelected ?? []).map((horse) => ({
        horseId: horse.id,
        isScratched: item.isScratched,
      }))
    )
    .filter((item) => item.horseId !== HORSE_NAME_DEFAULT)
    .groupBy('horseId')
    .values()
    .filter((group) => _.every(group, { isScratched: true }))
    .size()

  return (
    <p className="text-base text-black/50 font-normal">
      <span className={cn(entriesTotal === entriesScratched && entriesTotal > 0 && 'line-through')}>
        {count.classes} classes
      </span>
      ,{' '}
      <span className={cn(horsesTotal === horsesScratched && horsesTotal > 0 && 'line-through')}>
        {count.horses} horses
      </span>
      ,{' '}
      <span className={cn(feesTotal === feesScratched && feesTotal > 0 && 'line-through')}>
        {count.fees} fees
      </span>
      ,{' '}
      <span className={cn(ticketsTotal === ticketsScratched && ticketsTotal > 0 && 'line-through')}>
        {count.tickets} tickets
      </span>
      , {count.paperwork} signature missing
    </p>
  )
}
